<template>
  <section class="message-section">
    <div class="container">
      <div class="message-content">
        <SectionHeader :title="title" />
        <div data-aos="fade-up" data-aos-duration="600" class="description">
          <p v-html="description" />
        </div>
        <div
          v-if="signatureImage"
          data-aos="zoom-in"
          data-aos-duration="600"
          class="sign-image"
        >
          <img :src="generateImageUrl(signatureImage)" alt="sign" />
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import SectionHeader from "@/pageComponents/globalUi/section-header";
export default {
  name: "Message",
  components: {
    SectionHeader
  },
  props: {
    description: {
      type: String,
      default: ""
    },
    signatureImage: {
      type: String,
      default: ""
    },
    title: {
      type: String,
      default: "No Title"
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/scss/_variable.scss";
@import "@/scss/_mixins.scss";
.message-section {
  .message-content {
    .img-wrap {
      width: 500px;
      margin: 0 auto 50px;
      height: 325px;
      background: #21216480;
    }
    .description {
      p {
        font-family: $content-font;
        font-size: 14px;
        font-weight: 400;
        max-width: 1000px;
        color: #707070;
        text-align: center;
        margin: 10px auto 0 !important;
      }
    }
    .sign-image {
      width: 250px;
      margin: 20px auto 0;
      img {
        width: 100%;
        height: 100%;
        object-fit: contain;
      }
    }
  }
}
</style>
